import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "home" };
var _hoisted_2 = { class: "hero" };
var _hoisted_3 = { class: "hero-content col-12 col-md-7 p-3" };
var _hoisted_4 = { class: "buttons" };
import HomePlans from '@/pages/public/HomePlans.vue';
import HomeHowwork from './HomeHowwork.vue';
import HomeBenefits from './HomeBenefits.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Home',
    setup: function (__props) {
        return function (_ctx, _cache) {
            var _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("section", _hoisted_2, [
                    _cache[5] || (_cache[5] = _createElementVNode("img", {
                        src: "/imagenes/fef3deaf-89ae-4185-9235-e0b696a761e6.webp",
                        class: "img-fluid col-12 col-md-5"
                    }, null, -1)),
                    _createElementVNode("div", _hoisted_3, [
                        _cache[2] || (_cache[2] = _createElementVNode("h1", null, "Comparte cuentas, paga menos.", -1)),
                        _cache[3] || (_cache[3] = _createElementVNode("p", null, "Comparte, Ahorra y Disfruta. Tus plataformas favoritas, sin complicaciones.", -1)),
                        _createElementVNode("div", _hoisted_4, [
                            _cache[1] || (_cache[1] = _createElementVNode("a", {
                                href: "#planes",
                                class: "btn btn-primary"
                            }, "Explora planes", -1)),
                            _createVNode(_component_router_link, {
                                class: "btn btn-light",
                                to: "/registro"
                            }, {
                                default: _withCtx(function () { return _cache[0] || (_cache[0] = [
                                    _createTextVNode("Regístrate gratis")
                                ]); }),
                                _: 1
                            })
                        ]),
                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "features" }, [
                            _createElementVNode("span", null, "🔒 Seguro"),
                            _createElementVNode("span", null, "✅ Legal"),
                            _createElementVNode("span", null, "⚡ Fácil de usar")
                        ], -1))
                    ])
                ]),
                _createVNode(HomePlans),
                _createVNode(HomeHowwork),
                _createVNode(HomeBenefits)
            ]));
        };
    }
});
